var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.54346 10.1182L7.89416 12.0017C7.96197 12.0469 8.02978 12.0921 8.10512 12.1072C8.188 12.1298 8.27086 12.1298 8.3462 12.1072C8.42907 12.0996 8.51197 12.062 8.57978 12.0168C8.64759 11.9716 8.70786 11.9113 8.73799 11.836L12.4147 5.52979",
    stroke: "#21AB54",
    strokeWidth: 1.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7186 16.2813C14.74 15.3321 17.2306 11.3027 16.2815 7.28129C15.3323 3.25986 11.3029 0.769292 7.28146 1.71843C3.26003 2.66758 0.769432 6.69701 1.71858 10.7184C2.66772 14.7399 6.69718 17.2304 10.7186 16.2813Z",
    stroke: "#21AB54",
    strokeWidth: 1.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.cb07abab6cf151ee8024ea60c62371ec.svg";
export { ForwardRef as ReactComponent };